/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { themeColors } from './Constants';
import Checkbox from './Checkbox';
import CollapsibleView from './CollapsibleView';
import formatDate from '../../core/support/formatDate';

type Props = {
  style?: StyleSet;
  marketTitle: string;
  dates: Array<string>;
  selectedItems: Set<string>;
  onChange: (arg0: string) => void;
  onSelectAll: () => void;
};

class MarketSelector extends Component<Props> {
  render() {
    let { dates, selectedItems, marketTitle, style } = this.props;
    const selectedCount = selectedItems.size;
    return (
      <CollapsibleView
        title={marketTitle}
        counter={`(${selectedItems.size})`}
        initialCollapseState={true}
        titleStyle={{ fontWeight: '600' }}
        style={[styles.root, style]}
        isChecked={
          selectedCount === 0
            ? false
            : selectedCount === dates.length
            ? true
            : null
        }
        onChecked={this.props.onSelectAll}
      >
        <Checkbox
          text="Select All"
          isChecked={dates.length === selectedItems.size}
          onChange={this.props.onSelectAll}
        />
        <View style={styles.items}>
          {dates.map((date) => (
            <View key={date} style={{ width: '33%' }}>
              <Checkbox
                text={formatDate(date, {
                  fromUTC: true,
                  includeDayOfWeek: true,
                })}
                isChecked={selectedItems.has(date)}
                onChange={() => this.props.onChange(date)}
                style={styles.checkbox}
                textStyle={
                  {
                    whiteSpace: 'nowrap',
                    overflow: 'visible',
                  } as never
                }
              />
            </View>
          ))}
        </View>
      </CollapsibleView>
    );
  }
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    borderWidth: 1,
    borderColor: themeColors.borderGrey,
    backgroundColor: themeColors.white,
    borderRadius: 3,
    paddingVertical: 6,
    paddingHorizontal: 12,
    marginTop: 10,
  },
  items: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  checkbox: {
    marginRight: 7,
  },
});

export default MarketSelector;
